import {
  SET_GLOBAL_LOADING,
  SET_NOT_LOGIN_NOTIFY,
  SET_CONFIRM_AUTH_ELE,
  SET_IS_IPVALIDATE,
  SET_SHOW_IPVALIDATION,
  SET_FINGER_PRINT,
} from './action'

const initialState = {
  isLoading: false,
  showNotLoginNotify: false,
  triggerElement: null,
  isIpValid: true,
  isShowIpValidation: true,
  deviceInfo: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_GLOBAL_LOADING:
      return {
        ...state,
        isLoading: action.data,
      }

    case SET_FINGER_PRINT:
      return {
        ...state,
        deviceInfo: action.data,
      }

    case SET_SHOW_IPVALIDATION:
      return {
        ...state,
        isShowIpValidation: action.data,
      }

    case SET_NOT_LOGIN_NOTIFY:
      return {
        ...state,
        showNotLoginNotify: action.data,
      }

    case SET_CONFIRM_AUTH_ELE:
      return {
        ...state,
        triggerElement: action.data,
      }

    case SET_IS_IPVALIDATE:
      return {
        ...state,
        // isIpValid: action.data,
        isIpValid: true,
      }

    default:
      return state
  }
}
